import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss']
})
export class QuizComponent implements OnInit {

  @Output() addInteraction = new EventEmitter();
  @Input() interaction;

  environment = environment;
  quizForm = new FormGroup({
    domanda: new FormControl('', [Validators.required]),
    sottotitolo: new FormControl('',),
    info: new FormControl(''),
    lat: new FormControl(''),
    lng: new FormControl(''),
    hasImage: new FormControl(false, [Validators.required]),
    immagineDomanda: new FormControl(null),
  });
  
  alphaIndex = [ 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z' ];


  constructor() { }

  ngOnInit(): void {

    if (this.interaction) { // devo riempire i field
      this.populateForm();
      if (!this.interaction.interactionData)  this.interaction.interactionData.risposteType = 'text';
    } else {
      this.interaction = {interactionType: 'quiz'};
    }
  }

  // convenience getter for easy access to form fields
  get f(): any {
    return this.quizForm.controls;
  }

  populateForm(): void {
    this.f.domanda.setValue(this.interaction.title);
    this.f.sottotitolo.setValue(this.interaction.subtitle);
    this.interaction.interactionData && this.interaction.interactionData.info ? this.f.info.setValue(this.interaction.interactionData.info) : '';
    this.interaction.interactionData && this.interaction.interactionData.coordinates ? this.f.lat.setValue(this.interaction.interactionData.coordinates.lat) : '';
    this.interaction.interactionData && this.interaction.interactionData.coordinates ? this.f.lng.setValue(this.interaction.interactionData.coordinates.lng) : '';
    this.interaction.image ? this.f.hasImage.setValue(true) : this.f.hasImage.setValue(false);
    this.interaction.image ? this.f.immagineDomanda.setValue(this.interaction.image) : this.f.immagineDomanda.setValue(null);
  }

  setImageUrl(event, target): void {
    if(target === 'featuredImage') {
      this.f.immagineDomanda.setValue(event ? event.filename : null);
      this.interaction.image = event ? event.filename : null;
    }
  }

  validateDomanda(): boolean {
    if (!this.f.domanda.errors && !this.f.sottotitolo.errors) {
      if (this.f.hasImage.value) {
        if (this.f.immagineDomanda.value) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

  validateRisposte(): boolean {
    let valid = true;
    if (!this.interaction.interactionData.risposte.length) {
      valid = false;
    } else {
      if (this.interaction.interactionData.risposte.length < 2) {
        valid = false;
      }
      switch (this.interaction.interactionData) {
        case 'text':
          this.interaction.interactionData.risposte.forEach(r => {
            if (!r.label) {
              valid = false;
            }
          });
          break;
        case 'text-image':
          this.interaction.interactionData.risposte.forEach(r => {
            if (!r.label || !r.image) {
              valid = false;
            }
          });
          break;
        case 'image':
          this.interaction.interactionData.risposte.forEach(r => {
            if (!r.image) {
              valid = false;
            }
          });
          break;
        default:
          break;
      }
    }
    return valid;
  }

  validateRisultato(): boolean {
    return this.interaction.interactionData.risposte.filter(r => r.value).length;
  }

  setDomanda(): void {
    this.interaction.title = this.f.domanda.value;
    if (this.f.hasImage) {
      this.interaction.image = this.f.immagineDomanda.value;
    }
    this.interaction.subtitle = this.f.sottotitolo.value;
  }

  setRisposta(index, event): void {
    this.interaction.interactionData.risposte[index].label= event.target.value;
  }

  setImmagineRisposta(index, event): void {
    this.interaction.interactionData.risposte[index].image = event ? event.filename : null;
  }

  deleteRisposta(risposta): void {
    if (this.interaction.interactionData.risposteType !== 'image') {
      this.interaction.interactionData.risposte = this.interaction.interactionData.risposte.filter(r => r.label !== risposta.label)
    } else {
      console.log('sono qui',risposta);
      this.interaction.interactionData.risposte = this.interaction.interactionData.risposte.filter(r => r.image !== risposta.image);
    }
  }

  setRisultatoQuiz(index): void {
    this.interaction.interactionData.risposte = this.interaction.interactionData.risposte.map(r => {
      return {
        ...r,
        value: false
      }
    });
    this.interaction.interactionData.risposte[index].value = true;
  }

  onAddInteraction(): void {
    for (let index = 0; index < this.interaction.interactionData.risposte.length; index++) {
      this.interaction.interactionData.risposte[index].id = index + 1;
    }
    this.interaction.interactionData.info = this.f.info.value;
    this.interaction.interactionData.coordinates = {
      lat: this.f.lat.value,
      lng: this.f.lng.value
    }
    this.addInteraction.emit(this.interaction);
  }

}
